import { ActionIcon, Box, Button, Tooltip } from "@mantine/core";
import { IconLock, IconLockOpen, IconStarFilled } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { useProfileStore, useSessionStore } from "../../stores/UserStore";
import { useLanguage } from "../../stores/LanguageStore";

const Locked = ({
  children,
  top = "50%",
  left,
  right,
  bottom,
  disableLock,
  boxProps,
  buttonProps,
  iconOnly,
  tooltipProps,
}) => {
  const lang = useLanguage((s) => s.language);
  const reseller = useSessionStore((s) => s.reseller);
  const profile = useProfileStore((s) => s.profile);

  const locked =
    disableLock || reseller?.name !== "Magileads"
      ? false
      : !profile?.subscriptions ||
      !profile?.subscriptions?.active;

  if (locked) {
    return (
      <Tooltip
        label={lang.profile.locked}
        ta={"center"}
        color="red.8"
        maw={400}
        withArrow
        offset={0}
        {...tooltipProps}
      >
        <Box pos={"relative"} w={"100%"} {...boxProps}>
          {iconOnly ? (
            <ActionIcon
              variant="light"
              component={Link}
              to={"/settings/subscription/account"}
              pos={"absolute"}
              top={top}
              left={left}
              right={right}
              bottom={bottom}
              style={{ transform: "translateY(-50%)", zIndex: 8 }}
              color="red"
              {...buttonProps}
            >
              <IconLock
                size={
                  buttonProps?.size === "xs"
                    ? 14
                    : buttonProps?.size === "sm"
                      ? 16
                      : 18
                }
              />
            </ActionIcon>
          ) : (
            <Button
              variant="light"
              leftSection={
                <IconLock size={buttonProps?.size === "xs" ? 16 : 18} />
              }
              component={Link}
              to={"/settings/subscription/account"}
              pos={"absolute"}
              top={top}
              left={left}
              right={right}
              bottom={bottom}
              style={{ transform: "translateY(-50%)", zIndex: 8 }}
              color="red"
              {...buttonProps}
            >
              Unlock
            </Button>
          )}

          {children(true)}
        </Box>
      </Tooltip>
    );
  }
  return children(false);
};

export default Locked;
